import React from 'react';
import PropTypes from 'prop-types';

const ForgotPasswordButton = ({ changeState }) => (
  <div className="auth__forgot-password">
    <a
      onClick={() => changeState('forgotPassword')}
    >
      Forgot password?
    </a>
  </div>
);

ForgotPasswordButton.propTypes = {
  changeState: PropTypes.func.isRequired,
};

export default ForgotPasswordButton;



// WEBPACK FOOTER //
// ./src/components/Authentication/components/ForgotPasswordButton.js